/* Produktgalerie im Snocks-Stil (snippets/mil-galerie.liquid). Ohne Framework. */
if (!customElements.get('mil-galerie')) {
  customElements.define(
    'mil-galerie',
    class MilGalerie extends HTMLElement {
      connectedCallback() {
        this.spur = this.querySelector('.mil-galerie__spur');
        this.folien = Array.from(this.querySelectorAll('.mil-galerie__folie'));
        this.thumbs = Array.from(this.querySelectorAll('.mil-thumb'));
        this.punkteBox = this.querySelector('.mil-galerie__punkte');
        this.merkmal = this.querySelector('[data-mil-merkmal]');
        this.infoButton = this.querySelector('.mil-galerie__info-button');
        this.tooltip = this.querySelector('.mil-galerie__tooltip');
        this.aktiv = 0;
        this.zurueck = this.querySelector('[data-mil-zurueck]');
        this.weiter = this.querySelector('[data-mil-weiter]');
        if (this.zurueck) this.zurueck.addEventListener('click', () => this.gehe(this.aktiv - 1));
        if (this.weiter)
          this.weiter.addEventListener('click', () => {
            if (this.aktiv + 1 >= this.sichtbareFolien().length && !this.offen) this.alleZeigen();
            this.gehe(this.aktiv + 1);
          });

        this.spur.addEventListener('scroll', () => window.requestAnimationFrame(() => this.ausScroll()), { passive: true });
        this.thumbs.forEach((t) =>
          t.addEventListener('click', () => {
            if (t.querySelector('[data-mil-mehr]') && !this.offen) {
              this.alleZeigen();
              this.gehe(Number(t.dataset.index));
              return;
            }
            this.gehe(Number(t.dataset.index));
          })
        );
        this.addEventListener('click', (e) => {
          const punkt = e.target.closest('.mil-punkt');
          if (punkt) {
            if (punkt.hasAttribute('data-mil-alle')) {
              this.alleZeigen();
              this.gehe(Number(this.dataset.sichtbar));
            } else this.gehe(Number(punkt.dataset.index));
          }
          const video = e.target.closest('.mil-video');
          if (video) this.videoStarten(video);
        });

        // Tooltip „Mehr Infos“: Tippen, Hover und Fokus; schließt per Tippen außerhalb und Esc
        this.infoButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.tooltipZeigen(this.tooltip.hidden);
        });
        if (window.matchMedia('(hover: hover)').matches) {
          this.infoButton.addEventListener('mouseenter', () => this.tooltipZeigen(true));
          this.infoButton.addEventListener('mouseleave', () => this.tooltipZeigen(false));
        }
        this.infoButton.addEventListener('focus', () => this.tooltipZeigen(true));
        this.infoButton.addEventListener('blur', () => this.tooltipZeigen(false));
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.tooltipZeigen(false);
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.tooltipZeigen(false);
        });

        this.markieren(0);
      }

      sichtbareFolien() {
        return this.folien.filter((f) => !f.hidden);
      }

      ausScroll() {
        const breite = this.spur.clientWidth || 1;
        const i = Math.round(this.spur.scrollLeft / breite);
        if (i !== this.aktiv) this.markieren(i);
      }

      gehe(i, sanft = true) {
        const ziel = this.sichtbareFolien()[i];
        if (!ziel) return;
        this.spur.scrollTo({ left: ziel.offsetLeft - this.spur.offsetLeft, behavior: sanft ? 'smooth' : 'auto' });
        this.markieren(i);
      }

      markieren(i) {
        this.aktiv = i;
        const folie = this.sichtbareFolien()[i];
        this.thumbs.forEach((t) => t.classList.toggle('is-aktiv', Number(t.dataset.index) === i));
        this.querySelectorAll('.mil-punkt:not([data-mil-alle])').forEach((p) =>
          p.classList.toggle('is-aktiv', Number(p.dataset.index) === i)
        );
        // Pfeile: am ersten Bild kein Zurück, am letzten Bild (auch hinter „+N“) kein Weiter
        if (this.zurueck) this.zurueck.hidden = i <= 0;
        if (this.weiter) this.weiter.hidden = i >= this.folien.length - 1;
        if (folie) {
          this.merkmal.textContent = folie.dataset.merkmal || '';
          this.tooltip.textContent = folie.dataset.info || '';
          this.infoButton.hidden = !folie.dataset.info;
        }
        this.tooltipZeigen(false);
      }

      tooltipZeigen(an) {
        if (!this.tooltip.textContent) an = false;
        this.tooltip.hidden = !an;
        this.infoButton.setAttribute('aria-expanded', String(an));
      }

      alleZeigen() {
        if (this.offen) return;
        this.offen = true;
        this.folien.forEach((f) => (f.hidden = false));
        this.thumbs.forEach((t) => (t.hidden = false));
        this.querySelectorAll('[data-mil-mehr]').forEach((m) => m.remove());
        if (this.punkteBox) {
          this.punkteBox.innerHTML = '';
          this.folien.forEach((f, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'mil-punkt';
            b.dataset.index = String(i);
            b.setAttribute('aria-label', `Bild ${i + 1} anzeigen`);
            this.punkteBox.appendChild(b);
          });
        }
      }

      videoStarten(button) {
        const typ = button.dataset.typ;
        const quelle = button.dataset.quelle;
        let el;
        if (typ === 'mp4') {
          el = document.createElement('video');
          el.src = quelle;
          el.controls = true;
          el.autoplay = true;
          el.playsInline = true;
          el.preload = 'none';
        } else if (typ === 'youtube') {
          el = document.createElement('iframe');
          el.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(quelle)}?autoplay=1&rel=0`;
          el.allow = 'autoplay; encrypted-media; picture-in-picture';
          el.allowFullscreen = true;
          el.title = button.getAttribute('aria-label') || 'Video';
        } else if (typ === 'vimeo') {
          el = document.createElement('iframe');
          el.src = `https://player.vimeo.com/video/${encodeURIComponent(quelle)}?autoplay=1&dnt=1`;
          el.allow = 'autoplay; fullscreen';
          el.title = button.getAttribute('aria-label') || 'Video';
        }
        if (!el) return;
        el.className = 'mil-video__player';
        el.style.aspectRatio = button.style.aspectRatio;
        button.replaceWith(el);
      }

      /* Wird vom Theme beim Variantenwechsel aufgerufen (global.js updateMedia). */
      setActiveMedia(mediaId) {
        const folie = this.folien.find((f) => f.dataset.mediaId === mediaId);
        if (!folie) return;
        if (folie.hidden) this.alleZeigen();
        const i = this.sichtbareFolien().indexOf(folie);
        this.gehe(i, false);
      }
    }
  );
}
